module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "team__member-reveal"
  }, [_c('p', {
    staticClass: "team__member-copy team__member-copy--desktop",
    domProps: {
      "textContent": _vm._s(_vm.spliceContent(_vm.baseCopy))
    }
  }), _vm._v(" "), (!_vm.baseReveal) ? _c('button', {
    staticClass: "team__member-cta",
    domProps: {
      "textContent": _vm._s(_vm.$parent.buttonTextPrimary)
    },
    on: {
      "click": function($event) {
        _vm.toggleCopy()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "team__copy-container"
  }, [_c('transition-panel', [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.baseReveal),
      expression: "baseReveal"
    }],
    staticClass: "paragraph-01 team__member-copy",
    domProps: {
      "textContent": _vm._s(_vm.joinContent(_vm.baseCopy))
    }
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.baseReveal),
      expression: "baseReveal"
    }],
    staticClass: "team__member-cta",
    domProps: {
      "textContent": _vm._s(_vm.$parent.buttonTextSecondary)
    },
    on: {
      "click": function($event) {
        _vm.toggleCopy()
      }
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f1ce975c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaseReveal.vue
// module id = 271
// module chunks = 1